import { useQuery } from "@tanstack/react-query";
import { TableName } from "../../constants/table";
import {
  deleteEntity,
  getAllEntities,
  getFilteredEntities,
  getByPartitionKey,
} from "../services/api-service";

const tableName = TableName.DefaultLedger;

export const fetchDefaultLedger = async (tenantId: string) => {
  const defaultLedger = await getFilteredEntities(tableName, tenantId);
  const tenants = await getAllEntities(TableName.Tenant);
  const companyMasters = await getByPartitionKey(
    TableName.CompanyMaster,
    tenantId
  );
  const commonCodes = await getByPartitionKey(TableName.CommonCode, tenantId);

  const data = defaultLedger.map(
    (item: { PartitionKey: string; CompanyId: string; VendorId?: string }, index: number) => {
      const tenantName = tenants.find(
        (e: { PartitionKey: string }) =>
          e.PartitionKey?.toLowerCase() === item.PartitionKey?.toLowerCase()
      )?.RowKey;

      const matchingCompany = companyMasters.find(
        (e: { RowKey: string }) => e.RowKey === item.CompanyId
      );

      const matchingVendor = item.VendorId
        ? commonCodes.find(
            (e: { RowKey: string }) => e.RowKey === item.VendorId
          )
        : null;

      return {
        ...item,
        id: index,
        tenantName,
        companyName: matchingCompany?.CompanyName,
        vendorName: matchingVendor?.CommonCode ?? "",
      };
    }
  );
  return data;
};

export const deleteDefaultLedger = async (payload: {
  PartitionKey: string;
  RowKey: string;
}) => {
  const { PartitionKey, RowKey } = payload;
  await deleteEntity(tableName, PartitionKey, RowKey);
};

export const useGetDefaultLedger = (tenantId: string) =>
  useQuery({
    queryKey: ["fetchDefaultLedger", tenantId],
    queryFn: async () => fetchDefaultLedger(tenantId),
  });
